import React from 'react'

import { IStorePremiumProduct } from 'protos'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

interface Props {
  details: IStorePremiumProduct['detailItem']
  className?: string
}

const PremiumMembershipDetails: React.SFC<Props> = ({ className, details }) => (
  <>
    {details && (
      <List className={className} disablePadding dense>
        {details.map((item) => (
          <ListItem key={`pmd-item-${item.title}`} disableGutters dense>
            <ListItemIcon>
              <CheckCircleIcon />
            </ListItemIcon>
            <ListItemText primary={item.title} secondary={item.detail} />
          </ListItem>
        ))}
      </List>
    )}
  </>
)

export default PremiumMembershipDetails
